import { render, staticRenderFns } from "./MIPModal.vue?vue&type=template&id=90b332aa&"
import script from "./MIPModal.vue?vue&type=script&lang=ts&"
export * from "./MIPModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports